import client from './client';
import { unwrapData } from './response';

export const listCategories = async (params = {}) => {
  const response = await client.get('/marketplace/admin/categories', { params });
  return unwrapData(response);
};

export const createCategory = async (payload) => {
  const response = await client.post('/marketplace/admin/categories', payload);
  return unwrapData(response, null);
};

export const updateCategory = async (id, payload) => {
  const response = await client.put(`/marketplace/admin/categories/${id}`, payload);
  return unwrapData(response, null);
};

export const deleteCategory = async (id) => {
  const response = await client.delete(`/marketplace/admin/categories/${id}`);
  return unwrapData(response, null);
};

export const listProducts = async (params = {}) => {
  const response = await client.get('/marketplace/admin/products', { params });
  return unwrapData(response);
};

export const getProduct = async (id) => {
  const response = await client.get(`/marketplace/admin/products/${id}`);
  return unwrapData(response, null);
};

export const createProduct = async (payload) => {
  const response = await client.post('/marketplace/admin/products', payload);
  return unwrapData(response, null);
};

export const updateProduct = async (id, payload) => {
  const response = await client.put(`/marketplace/admin/products/${id}`, payload);
  return unwrapData(response, null);
};

export const deleteProduct = async (id) => {
  const response = await client.delete(`/marketplace/admin/products/${id}`);
  return unwrapData(response, null);
};

export const uploadProductImage = async (id, file, payload = {}) => {
  const formData = new FormData();
  formData.append('photo', file);

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value);
    }
  });

  const response = await client.post(`/marketplace/admin/products/${id}/images`, formData);
  return unwrapData(response, null);
};

export const listOrders = async (params = {}) => {
  const response = await client.get('/marketplace/admin/orders', { params });
  return unwrapData(response);
};

export const getOrder = async (id) => {
  const response = await client.get(`/marketplace/admin/orders/${id}`);
  return unwrapData(response, null);
};

export const updateOrderStatus = async (id, status) => {
  const response = await client.put(`/marketplace/admin/orders/${id}/status`, { status });
  return unwrapData(response, null);
};
